// extracted by mini-css-extract-plugin
export default {"root":"MZWr2_8XEdnM42PTNnhw","wrap":"wRHUI5YQgLbk9jOpIBFo","headline":"ZwO4s732qKQ5A_c0NLYi uN5d_RhKgw_fnx1KJrsr","endorsements":"_LgyHL6Z3LDa3KGzWPLJ","img":"_WiE1WpxmOgdVFXS2NhQ"};